import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AdminLayout from './AdminLayout';
import { getSections, deleteSection } from '../../services/api';
import './admin.css';

const SectionsList = () => {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    loadSections();
  }, []);

  const loadSections = async () => {
    try {
      setLoading(true);
      const response = await getSections(true);
      setSections(response.sections || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Êtes-vous sûr de vouloir supprimer cette section ?')) {
      return;
    }

    try {
      await deleteSection(id, 'section');
      setSections(sections.filter(s => s.id !== id));
    } catch (err) {
      setError(err.message);
    }
  };

  const getTypeLabel = (type) => {
    const labels = {
      hero: 'Cover (Hero)',
      book: 'Livre (Détails)',
      author: 'Autrice',
      pricing: 'Prix',
      contact: 'Contact',
    };
    return labels[type] || type;
  };

  return (
    <AdminLayout>
      <div className="admin-page">
        <header className="admin-page-header">
          <div>
            <h1>Sections (Livres)</h1>
            <p>Gérez les sections de présentation des livres</p>
          </div>
          <button
            onClick={() => navigate('/admin/sections/new')}
            className="admin-btn admin-btn-primary"
          >
            + Nouvelle section
          </button>
        </header>

        {error && <div className="admin-alert admin-alert-error">{error}</div>}

        {loading ? (
          <div className="admin-loading">
            <div className="spinner"></div>
          </div>
        ) : (
          <div className="admin-table-container">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Ordre</th>
                  <th>Nom</th>
                  <th>Type</th>
                  <th>Statut</th>
                  <th>Dernière modification</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {sections.map((section) => (
                  <tr key={section.id}>
                    <td>{section.order}</td>
                    <td>
                      <strong>{section.name}</strong>
                    </td>
                    <td>
                      <span className="admin-badge">{getTypeLabel(section.type)}</span>
                    </td>
                    <td>
                      <span className={`admin-status ${section.isActive ? 'active' : 'inactive'}`}>
                        {section.isActive ? 'Actif' : 'Inactif'}
                      </span>
                    </td>
                    <td>
                      {new Date(section.updatedAt).toLocaleDateString('fr-FR')}
                    </td>
                    <td className="admin-actions">
                      <Link
                        to={`/admin/sections/${section.id}`}
                        className="admin-btn admin-btn-sm"
                      >
                        Modifier
                      </Link>
                      <button
                        onClick={() => handleDelete(section.id)}
                        className="admin-btn admin-btn-sm admin-btn-danger"
                      >
                        Supprimer
                      </button>
                    </td>
                  </tr>
                ))}
                {sections.length === 0 && (
                  <tr>
                    <td colSpan="6" className="admin-table-empty">
                      Aucune section créée.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default SectionsList;

